<template>
	<div>
		<div v-if="isPc == true" class="breadcrumb greyfont warp">
			<ul class="greyfont">
				<li><router-link to="/center">个人中心</router-link></li>
			</ul>
		</div>

		<div :class="isPc == true ? 'center warp' : 'center-mob'">
			<div>
				<HospitalGUI v-if="isPc == true"></HospitalGUI>

				<div :class="isPc == true ? 'tabar_bg' : 'tabar_bg-mob'">
					<p>个人中心</p>
				</div>

				<!-- 登录 -->
				<div v-show="token == false" :class="isPc == true ? 'userLogin' : 'userLogin-mob warp-mob'">
					<div class="userLogin_title bluefont">用户登录</div>
					<p class="userLogin_mark greyfont">未注册的用户会在登录时自动注册账号</p>
					<div class="userLogin_input">
						<div>手机号</div>
						<input type="text" placeholder="请填写手机号" v-model="mobile" />
						<p @click="getCode(12)">{{ count_down }}</p>
					</div>
					<div class="userLogin_input">
						<div>验证码</div>
						<input type="text" placeholder="请填写验证码" v-model="code" />
					</div>
					<div @click="login()" class="userLogin_btn">登录</div>
				</div>

				<!-- 个人中心 -->
				<!-- <router-link to="/center/registerOnline">new</router-link> -->

				<!-- <router-view></router-view> -->

				<div v-show="token == true" :class="isPc == true ? 'center_List' : 'center_List-mob warp-mob'">
					<ul>
						<li>
							<img src="../static/imgs/center1.png" />
							<div @click="gopersonMsg()">个人信息</div>
						</li>
						<li>
							<img src="../static/imgs/center1.png" />
							<div><router-link to="/registerOnline">线上挂号</router-link></div>
						</li>
						<li>
							<img src="../static/imgs/center1.png" />
							<div>病例/体检报告</div>
						</li>
						<li>
							<img src="../static/imgs/center1.png" />
							<div>挂号记录</div>
						</li>
						<li>
							<img src="../static/imgs/center1.png" />
							<div>账单记录</div>
						</li>
						<li>
							<p @click="exit()">退出当前账号</p>
						</li>
					</ul>
				</div>
			</div>
		</div>

		<div class="foot-mob"></div>
	</div>
</template>

<script>
import HospitalGUI from '../components/HospitalGUI.vue';

export default {
	name: 'WebLijinhospitalCenter',
	components: {
		HospitalGUI
	},
	data() {
		return {
			isPc: true,
			token: false,
			count_down: '获取验证码',
			mobile: '',
			code: '',
			canlogin: true,
			member: null
		};
	},

	mounted() {
		if (document.body.clientWidth <= 820) {
			this.isPc = false;
			console.log(this.isPc);
		} else {
			this.isPc = true;
			console.log(this.isPc);
		}
		let old_member_json = localStorage.getItem('eden_member');
		if (typeof old_member_json == 'string') {
			let old_member = JSON.parse(old_member_json);
			if (old_member) {
				this.member = old_member;
				this.token = true;
			}
		}
	},

	methods: {
		login() {
			if (this.canlogin) {
				this.canlogin = false;
				this.$axios({
					url: 'http://www.ljxzxyy.cn/api/index/autologin',
					params: {
						mobile: this.mobile,
						code: this.code
					}
				})
					.then((res) => {
						//请求成功
						console.log('autologin', res.data);
						if (res.data.code) {
							let member = res.data.data;
							localStorage.setItem('eden_member', JSON.stringify(member));
							this.member = member;
							this.token = true;
						} else {
							this.$message({
								message: res.data.msg,
								type: 'error'
							});
						}
						this.canlogin = true;
					})
					.catch((error) => {
						//请求失败
						console.log('autologin', error);
					});
			}
		},
		exit() {
			localStorage.setItem('eden_member', null);
			this.member = null;
			this.token = false;
		},
		gocenter() {
			this.$router.push('/center');
		},
		gopersonMsg() {
			this.$router.push('/personMsg');
		},
		getCode(s) {
			if (this.count_down == '获取验证码') {
				// 验证码
				// 倒计时
				let _t = this;
				_t.count_down = s;
				let count_down_timer = setInterval(function () {
					_t.count_down -= 1;
					if (_t.count_down <= 0) {
						clearInterval(count_down_timer);
						_t.count_down = '获取验证码';
					}
				}, 1000);
			}
		}
	}
};
</script>

<style lang="scss" scoped></style>
